import {
  Box,
  Checkbox,
  FieldMessage,
  Heading,
  Inline,
  Stack,
  Text,
} from 'braid-design-system';
import { useFormContext } from 'react-hook-form';

import { TextLink } from 'src/components/Link/Link';
import { TRACKING_CODES } from 'src/constants';

export const Terms = () => {
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext();

  return (
    <Stack space="medium">
      <Box paddingTop="gutter">
        <Heading level="3">Terms & Conditions</Heading>
      </Box>
      <Stack space="xsmall">
        <Inline space="none" alignY="center">
          <Checkbox
            id="reviewDocs"
            checked={watch('reviewDocs')}
            label="I have reviewed the"
            tone={!Boolean(errors.reviewDocs) ? 'neutral' : 'critical'}
            {...register('reviewDocs')}
          />
          <Text weight="strong">
            &nbsp;
            <TextLink
              href="https://developer.seek.com"
              target="_blank"
              tracking={TRACKING_CODES.developer_site_link_clicked}
            >
              technical documentation
            </TextLink>
            .
          </Text>
        </Inline>
        {errors.reviewDocs?.message ? (
          <FieldMessage
            id="reviewDocs"
            message={errors.reviewDocs?.message as string}
            tone="critical"
          />
        ) : null}
      </Stack>

      <Stack space="gutter">
        <Text>
          All personal information submitted by you as part of this form will be
          used by us in accordance with our{' '}
          <TextLink
            href="/privacy"
            product="candidate"
            tracking={TRACKING_CODES.privacy_link_clicked}
          >
            Privacy Statement
          </TextLink>
          .
        </Text>
        <Text>
          By submitting an integration request, you confirm you have read,
          understood and accepted the{' '}
          <TextLink
            href="/partners/terms-of-use"
            tracking={TRACKING_CODES.api_terms_link_clicked}
          >
            SEEK API Terms of Use
          </TextLink>{' '}
          relevant to the solutions you have requested.
        </Text>
      </Stack>
    </Stack>
  );
};
